var globalSettings = {
    sitePrefix: null,
    apiDomain: 'https://overseas.tiktime.net',
    areaSites: {
        'eu': 'https://eu.mobvoi.com',
        'au': 'https://au.mobvoi.com',
        'jp': 'https://jp.mobvoi.com',
        'uk': 'https://uk.mobvoi.com',
        'sg': 'https://sg.mobvoi.com',
        'ca': 'https://ca.mobvoi.com',
        'hk': 'https://hk.mobvoi.com',
        'en': 'https://www.mobvoi.com'
    },
    siteArea: function (){
        var self = this;
        var url = window.location.href;
        var currentSite;
        for (var key in self.areaSites) {
            if (url.indexOf(key + '.mobvoi.com') > -1) {
                self.sitePrefix = key;
                break;
            } else if (url.indexOf('www.mobvoi.com') > -1) {
                self.sitePrefix = 'en';
                break;
            }
        }
    }
}

globalSettings.siteArea();

if (globalSettings.sitePrefix !== 'en') {
    shopifyCountrySettings.init(globalSettings.sitePrefix);
}
